import React from 'react';
import {
  Typography,
  Box,
  ButtonBase
} from 'components';
import { useHistory, useParams } from 'react-router-dom';
import { Avatar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    borderRadius: 10,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(2),
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      transition: '0.3s'
    }
  },
  avatarLarge: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight: theme.spacing(2)
  },
  profileTag: {
    borderRadius: theme.shape.borderRadius,
    padding: '4px 8px',
    fontSize: '0.75rem',
    fontWeight: 400,
    margin: '2px',
    display: 'inline-block',
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0'
  }
}));

const SharedProfileCard = ({ profileUser }) => {
  const classes = useStyles();
  const history = useHistory();
  const { id: groupId } = useParams();

  if (!profileUser) return null;
  
  const handleProfileClick = () => {
    history.push(`/shared/${groupId}/freelancer/${profileUser.id}`);
  };

  return (
    <ButtonBase 
      className={classes.card} 
      component="div" 
      onClick={handleProfileClick}
    >
      <Box p={2} display="flex" flexDirection="column" width="100%">
        <Box display="flex" alignItems="flex-start" mb={2}>
          {/* Avatar Section */}
          <Avatar 
            className={classes.avatarLarge}
            src={profileUser.avatar || undefined} 
            alt={profileUser.name}
          />

          {/* Name and Main Info */}
          <Box ml={2} flex={1}>
            <Typography variant="h5" gutterBottom>
              {profileUser.name}
            </Typography>
            
            {profileUser.title && (
              <Typography variant="body1" color="textSecondary">
                {profileUser.title}
              </Typography>
            )}
            
            {profileUser.city && (
              <Typography variant="body2" color="textSecondary">
                {profileUser.city}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Tags Section */}
        <Box mt={1} display="flex" flexWrap="wrap">
          {/* Roles */}
          {Array.isArray(profileUser.roles) && profileUser.roles.map((role, index) => (
            <span key={index} className={classes.profileTag}>
              {typeof role === 'string' ? role : role.name || 'Role'}
            </span>
          ))}
          
          {/* Union Status */}
          {profileUser.union && (
            <span className={classes.profileTag}>
              {profileUser.union}
            </span>
          )}
        </Box>
        
        {/* Diversity Tags */}
        {Array.isArray(profileUser.diversityTags) && profileUser.diversityTags.length > 0 && (
          <Box mt={2}>
            <Typography variant="subtitle2" gutterBottom>
              Diversity
            </Typography>
            <Box display="flex" flexWrap="wrap">
              {profileUser.diversityTags.map((tag, index) => (
                <span key={index} className={classes.profileTag}>
                  {tag}
                </span>
              ))}
            </Box>
          </Box>
        )}
        
        {/* Industries */}
        {Array.isArray(profileUser.industries) && profileUser.industries.length > 0 && (
          <Box mt={2}>
            <Typography variant="subtitle2" gutterBottom>
              Industries
            </Typography>
            <Box display="flex" flexWrap="wrap">
              {profileUser.industries.map((industry, index) => (
                <span key={index} className={classes.profileTag}>
                  {typeof industry === 'string' ? industry : industry.name || 'Industry'}
                </span>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </ButtonBase>
  );
};

export default SharedProfileCard;
